import variables from '../../variables.module.scss';

const MuiStepConnector = (breakpoints) => ({
  styleOverrides: {
    root: {
      marginTop: 8,
      top: 12,
      color: variables.stepConnectorBorder,
      [breakpoints.down('md')]: {
        top: 2,
        height: 2,
        left: 'calc(-50% + 10px)',
        right: 'calc(50% + 10px)',
      },
      left: 'calc(-50% + 19px)',
      right: 'calc(50% + 19px)',
    },
    line: {
      borderTopWidth: '2px',
      borderColor: variables.stepConnectorBorder,
      marginLeft: '-1px',
      marginRight: '-1px',
      marginTop: '-2px',
    },
  },
});

export default MuiStepConnector;
